import PropTypes from 'prop-types';

import { alpha, useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import cometeColors from '../../theme/cometeColors';

const IconCometeLink = ({ themed, sx }) => {
  const theme = useTheme();
  const { main, dark } = theme.palette.primary;
  const { main: cometeBlue, secondary: cometeYellow, secondaryLight: cometeYellowLight } = cometeColors;
  const cometeShape = themed ? alpha(main, 0.6) : cometeBlue;
  const gradientStart = themed ? alpha(dark, 0.6) : cometeYellowLight;
  const gradientEnd = themed ? alpha(dark, 0.6) : cometeYellow;

  return (
    <Box component="span" display="block" sx={{ width: 40, height: 40, ...sx }}>
      <svg width="100%" height="100%" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_828_11113)">
          <path
            d="M975.961 632.281C978.697 811.05 836.596 958.205 658.557 960.966C627.003 961.422 595.55 957.242 565.212 948.566C534.874 939.89 505.967 926.793 479.429 909.719C452.891 892.645 429.001 871.759 408.543 847.731C388.073 823.716 371.251 796.814 358.596 767.91L38 38L774.526 337.199C894.625 385.989 973.972 502.225 975.974 632.294L975.961 632.281Z"
            fill={cometeShape}
          />
          <path
            d="M653.365 936.987C634.458 936.975 615.59 935.156 597.025 931.569C578.46 927.981 560.288 922.638 542.735 915.603C525.183 908.567 508.352 899.89 492.457 889.671C476.562 879.452 461.667 867.743 448 854.708C448.848 839.626 452.556 824.848 458.921 811.143C465.287 797.438 474.208 785.072 485.193 774.689C496.178 764.307 509.048 756.096 523.095 750.501C537.154 744.905 552.138 742.013 567.273 742H781.054C792.937 742.013 804.744 743.794 816.108 747.292C827.46 750.779 838.229 755.945 848.062 762.601C857.895 769.258 866.677 777.342 874.119 786.588C881.56 795.834 887.583 806.128 892 817.143C838.469 888.585 753.795 935.421 657.997 936.899L653.365 937V936.987Z"
            fill="url(#paint0_radial_828_11113)"
          />
          <path
            d="M592.46 664.525C589.101 661.986 585.92 659.233 582.929 656.265C579.938 653.297 577.162 650.139 574.602 646.792C572.042 643.458 569.723 639.947 567.644 636.284C498.886 515.011 623.297 391.06 744.97 459.578C748.645 461.636 752.169 463.948 755.54 466.486C758.899 469.025 762.08 471.778 765.071 474.746C768.062 477.714 770.838 480.872 773.398 484.219C775.958 487.566 778.277 491.077 780.356 494.727C849.114 616 724.703 739.939 603.03 671.421C599.355 669.362 595.831 667.051 592.473 664.525H592.46Z"
            fill="url(#paint1_radial_828_11113)"
          />
        </g>
        <defs>
          <radialGradient
            id="paint0_radial_828_11113"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(528.167 769.336) rotate(28.169) scale(291.466 249.246)"
          >
            <stop stopColor={gradientStart} />
            <stop offset="1" stopColor={gradientEnd} />
          </radialGradient>
          <radialGradient
            id="paint1_radial_828_11113"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(593.5 475.187) rotate(50.5314) scale(229.422 231.333)"
          >
            <stop stopColor={gradientStart} />
            <stop offset="1" stopColor={gradientEnd} />
          </radialGradient>
          <clipPath id="clip0_828_11113">
            <rect width="1000" height="1000" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Box>
  );
};

IconCometeLink.propTypes = {
  sx: PropTypes.object,
  themed: PropTypes.bool
};

export default IconCometeLink;
